import { Injectable } from '@angular/core';
import { ApiService } from '../api-service/api.service';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { UIRouter, Transition } from "@uirouter/angular";

@Injectable()
export class AuditTrailService {

  private _auditTrailItems: BehaviorSubject<any>
  private _customerId: any
  private _auditTrailClassName:BehaviorSubject<any>
  private dateQueryString:string

    constructor(private apiService: ApiService, private router: UIRouter) {

      this._auditTrailItems = new BehaviorSubject({})
      this._auditTrailClassName = new BehaviorSubject('')

    }

    get auditTrailItems(){
      return this._auditTrailItems
    }

    set auditTrailItems(data){
      this._auditTrailItems.next(data)
    }


    retrieveStaffAuditTrail(){

      return new Promise((resolve, reject) => {
        this.apiService.request('GET', '/audit/staff')
        .then((response)=>{
          this._auditTrailItems.next(response)
          resolve()
        })
        .catch(error=>{
          reject(error.message)
        })

      })
  
      
    }


    retrieveCustomerAuditTrail(id,startDate=null,endDate=null){

      if(startDate !== null && endDate !== null){

        this.dateQueryString = '?start='+startDate+'&end='+endDate;

      }

      return new Promise((resolve, reject) => {
        this.apiService.request('GET', '/audit/:customerId', {customerId: id})
        .then((response)=>{
          this._auditTrailItems.next(response)
          resolve()
        })
        .catch(error=>{
          console.log(error)
          reject(error.message)
        })

      })

    }


    insertAuditTrailInternalNote(auditTrailItem){

      
      this.apiService.request('POST', '/audit/internal', null, auditTrailItem)
      .then((response) => {
        this.retrieveCustomerAuditTrail(this.router.globals.params.customerId);
      })
      .catch((error)=>{
        console.log(error)
      })

     
    }


    set auditTrailClassName(value){
      this._auditTrailClassName.next(value)
    }
    get auditTrailClassName(){
      return this._auditTrailClassName
    }



    addNewItemToStaffAuditTrail(item){

      

    }

    markTaskAsCompleted(auditTrailId){

      this.apiService.request('PUT', '/audit/'+auditTrailId+'/task-complete', null, null)
      .then((response) => {
        this.retrieveCustomerAuditTrail(this.router.globals.params.customerId);
      })
      .catch((error)=>{
        console.log(error)
      })

    }
    
    

}


// WEBPACK FOOTER //
// /Users/matthewspringbett/sites/rooster/admin/src/app/audit-trail-service/audit-trail.service.ts